import type { ButtonSizeType } from '../abstracts'
import type { CollectEvent } from './collectEvent'
import type { BackgroundNoImageProtocol } from './design'
import type { EventsProtocol } from './event'
import type { IconicProtocol } from './general'
import type { AlignMent, Shape } from './layout'
import type { RichTextContentProtocol } from './richtext'

export type ActionItemIconPosition = 'left' | 'right'

export type ActionItemFitType = 'auto' | 'contain'

export enum ActionItemPattern {
    primary = 'primary',
    secondary = 'secondary',
    custom = 'custom'
}

export type ButtonShowType = 'icon-name' | 'icon' | 'name'

export enum ButtonPattern {
    primary,
    secondary,
    custom
}

/**
 * 按钮 对象协议
 * buttonBlock or navbarButton
 */
export type ButtonProtocols = {
    name: string

    showType: ButtonShowType

    pattern?: ButtonPattern
} & IconicProtocol

export interface ButtonConfigure extends Omit<ButtonProtocols, 'pattern' | 'name'> {
    size: ButtonSizeType

    align: AlignMent

    shape: Shape

    radius: string

    // fillWay?: ActionItemFitType
    // 调整后的
    name: RichTextContentProtocol

    iconPosition: ActionItemIconPosition

    pattern: ActionItemPattern

    backgroundColor?: BackgroundNoImageProtocol

    borderColor?: BackgroundNoImageProtocol

    iconColor?: BackgroundNoImageProtocol

    color?: BackgroundNoImageProtocol

    collectEvents?: CollectEvent[]
}

export interface OperatorButtonConfigure extends ButtonConfigure {
    id: string
    fillWay?: ActionItemFitType
}

export type ButtonItem = {
    id: string
    iconPosition: ActionItemIconPosition
    color?: BackgroundNoImageProtocol
    iconColor?: BackgroundNoImageProtocol
    backgroundColor?: BackgroundNoImageProtocol
    borderColor?: BackgroundNoImageProtocol
    name: RichTextContentProtocol
    pattern: ActionItemPattern
    fillWay?: ActionItemFitType
} & Omit<ButtonProtocols, 'name' | 'pattern'> &
    EventsProtocol
